module.exports = __webpack_public_path__ + "static/media/hiw2.dd473fc8.svg";